export default __webpack_public_path__ + "static/media/ai.3f9a92a4.svg";